export default __webpack_public_path__ + "static/media/V340_E_BD.2c75fcd9.pdf";